class NoMorePendingActivities extends Error {}

export default NoMorePendingActivities;
